// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Creator
 */
export interface Creator {
  /**
   *
   */
  givenName: string;
  /**
   *
   */
  familyName: string;
  /**
   *
   */
  email: string;
}

/**
 * Check if a given object implements the Creator interface.
 */
export function instanceOfCreator(value: object): value is Creator {
  if (
    (!("givenName" in (value as Record<string, any>)) &&
      !("given_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["givenName"] === undefined &&
      (value as Record<string, any>)["given_name"] === undefined)
  )
    return false;
  if (
    (!("familyName" in (value as Record<string, any>)) &&
      !("family_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["familyName"] === undefined &&
      (value as Record<string, any>)["family_name"] === undefined)
  )
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function CreatorFromJSON(json: any): Creator {
  return CreatorFromJSONTyped(json, false);
}

export function CreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Creator {
  if (json == null) {
    return json;
  }
  return {
    givenName: json["given_name"],
    familyName: json["family_name"],
    email: json["email"],
  };
}

export function CreatorToJSON(json: any): Creator {
  return CreatorToJSONTyped(json, false);
}

export function CreatorToJSONTyped(
  value?: Creator | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    given_name: value["givenName"],
    family_name: value["familyName"],
    email: value["email"],
  };
}
